import tool from "@/utils/tool";
import axios from 'axios';
import {Toast} from 'vant';
import Qs from 'qs';
import setting from '@/settings.js';
import authConfig from '@/config/auth';
import Vue from 'vue'
import loading from './loading.vue'
import store from '@/store/index';
import sysConfig from "@/config/index";

(function () { //页面加载完后才会加载
    new Vue({
        el: "#app",
        data: {},
        method: {},
        render: function (createElements) { //组件渲染
            return createElements(loading)
        }
    })
})

// 添加一个计数器以跟踪请求次数
let requestCount = 0;


const api = axios.create({
    baseURL: process.env.VUE_APP_API_ROOT,
    timeout: 60000, //超时60秒
    responseType: 'json', //请求类型json
    loading: true, //请求过滤动画
    // withCredentials: true
})

const hasOwnProperty = function (obj, key) {
    if (obj == null || 'object' !== typeof obj) {
        return false;
    }
    return Object.prototype.hasOwnProperty.call(obj, key);
}

api.interceptors.request.use(
    config => {
        const token = tool.data.get('token');


        config.headers.token = token
        if (config.method != 'post' && config.method != 'get') {
            config.method = 'post';
        }
        // 设置请求为Ajax 方便后端识别
        config.headers['X-REQUESTED-WITH'] = 'XMLHttpRequest'

        if (config.url.substring(0, 1) === '/') {
            config.url = setting.API_URL + config.url.split('/', 2)[1]
        } else {
            config.url = setting.API_URL + config.url
        }

        let data = {};
        let isFormData = false;
        if (config.method == 'post') {
            if (config.data instanceof FormData || config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('form-data') >= 0) {
                // 如果是 FormData 类型（上传图片）
                config.data.append("token", token);
                isFormData = true
            } else {
                // 带上 token
                if (config.data == undefined) {
                    config.data = {}
                }
                data['token'] = token
            }
        } else {
            // 带上 token
            if (config.data == undefined) {
                config.data = {}
            }
            data['token'] = token
        }
        // console.log('config', config);
        config.loadingInstance = null

        if (config.loading) {
            //设置加载状态 把Loading实例放在config里面 放在api里面会导致多个请求时冲突
            config.loadingInstance = layer.load();
        }
        config.data = Object.assign(config.data, data);
        if (!isFormData) {
            config.data = Qs.stringify(config.data)
        }
        // console.log('config', config);
        return config
    }
)

api.interceptors.response.use(
    response => {
        //清除加载状态
        try {
            if (hasOwnProperty(response, 'config') &&
                hasOwnProperty(response.config, 'loadingInstance')) {
                layer.close(error.config.loadingInstance);
                // if (hasOwnProperty(response.config.loadingInstance, 'clear')) {

                //     response.config.loadingInstance.clear()
                // }
            } else {
                layer.closeAll();
                //Toast.clear()
            }
        } catch (error) {
            layer.closeAll();
            //Toast.clear()
        }
        // console.log('response.data', response.data);

        if (response.status == 200) {
            response.data.httpStatus = response.status
            if (response.data.code != 200) {
                if (response.data.code == authConfig.nologin.code) {
                    // Toast.fail(authConfig.nologin.message);
                    authConfig.nologin.action()
                    return Promise.reject(response.data)
                } else if (response.data.code == authConfig.noauth.code) {
                    // Toast.fail(authConfig.noauth.message);
                    authConfig.noauth.action()
                    return Promise.reject(response.data)
                } else {
                    return Promise.resolve(Object.assign(response.data, {
                        'data': typeof response.data.data == 'undefined' ? [] : response.data.data
                    }))
                }
            }
            // console.log('response.data', response.data)
            return Promise.resolve(response.data)
        } else if (response.status == authConfig.nologin.code) {
            // 未登录，跳转登录
            // Toast.fail(authConfig.nologin.message);
            authConfig.nologin.action()
        } else if (response.status == authConfig.noauth.code) {
            // 无权限，返回前页面
            // Toast.fail(authConfig.noauth.message);
            authConfig.noauth.action()
        }
        return Promise.resolve({'code': 500, 'httpStatus': response.status, 'msg': 'Api请求打开失败,请稍后再试~', 'data': []})
    },
    error => {
        //清除加载状态
        try {
            if (hasOwnProperty(error, 'config') && hasOwnProperty(error.config, 'loadingInstance')) {
                if (hasOwnProperty(error.config.loadingInstance, 'clear')) {
                    layer.close(error.config.loadingInstance);
                    // error.config.loadingInstance.clear()
                }
            } else {
                layer.closeAll();
                // Toast.clear()
            }
        } catch (error) {
            layer.closeAll();
            //Toast.clear()
        }
        // console.log('config', error.config);
        Toast.fail("服务器请求错误~\n请联系网站客服处理")
        return Promise.reject({'code': 500, 'httpStatus': 200, 'msg': 'Api请求打开失败,请稍后再试~', 'data': [], 'error': error})
    }
)

var http = {

    /** get 请求 */
    get: function (url, params = {}, config = {}) {
        return this.request('get', url, params, config);
    },

    /** post 请求 */
    post: function (url, data = {}, config = {}) {
        return this.request('post', url, data, config);
    },

    /** put 请求 */
    put: function (url, data = {}, config = {}) {
        return this.request('put', url, data, config);
    },

    /** patch 请求 */
    patch: function (url, data = {}, config = {}) {
        return this.request('patch', url, data, config);
    },

    /** delete 请求 */
    delete: function (url, data = {}, config = {}) {
        return this.request('delete', url, data, config);
    },

    /** jsonp 请求 */
    jsonp: function (url, name = 'jsonp') {
        // ... [保持不变] ...
    },
    /** 通用请求方法 */
    request: async function (method, url, data = {}, config = {}) {
        // 判断是否启用 WebSocket 并且是前三次请求
        const useWebSocket = sysConfig.SOCKET && requestCount <= 3;
        // console.log('config', config);
        if (useWebSocket && (!('ws' in config) || config.ws === true)) {
            try {
                // 使用 WebSocket 发送请求并等待响应
                return new Promise((resolve, reject) => {
                    store.dispatch('socket/send', {
                        method,
                        url,
                        data,
                        call: (response) => {
                            resolve(response);
                        }
                    });
                });
            } catch (error) {
                console.warn("WebSocket not ready or request failed:", error.message);
                // WebSocket 请求失败或未准备好时，回退到 Axios 请求
                return this.axiosRequest(method, url, data, config);
            }
        } else {
            // 直接使用 Axios 请求
            return this.axiosRequest(method, url, data, config);
        }
    },
    /** 使用 Axios 发起请求 */
    axiosRequest: function (method, url, data, config) {
        return new Promise((resolve, reject) => {
            api[method](url, data, config)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};



export default http;


// WEBPACK FOOTER //
// ./src/api/index.js